export enum AccessLevelEnum {
  Deny = 0,
  Execute = 1,
  Read = 2,
  Write = 3,
  Delete = 4,
}
